"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isNotSameColumns;

function isNotSameColumns(prevColumns, currentColumns) {
  if (prevColumns.length !== currentColumns.length) {
    return true;
  }

  return prevColumns.some(function (column, index) {
    return column.field !== currentColumns[index].field;
  });
}